import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { SmsConfigCreateRequestDTO, SmsConfigDTO, SmsConfigReadAllPaginatedRequestDTO, SmsConfigRequestDelete, SmsConfigUpdateRequestDTO } from './sms-config.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SmsConfigService } from './sms-config.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmmodalserviceService } from 'src/app/Shared/confirm-delete-modal/confirmmodalservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sms-config',
  templateUrl: './sms-config.component.html',
  styleUrls: ['./sms-config.component.css']
})
export class SmsConfigComponent {

  //Flags
  isLoading = false;
  isSubmitting: boolean = false;

  //Services
  User = inject(UserLoginService).User();
  private SmsConfigService = inject(SmsConfigService)
  modalService = inject(NgbModal)
  private confirmModal = inject(ConfirmmodalserviceService)

  //Items
  smsConfigList: SmsConfigDTO[] = []
  @ViewChild('smsConfigModalContent', { static: false }) smsConfigModalContent!: ElementRef;
  addsmsConfigModalContent!: NgbModalRef;

  smsConfigForm = new FormGroup({
    smsConfigId: new FormControl(0),
    companyId: new FormControl(0),
    branchId: new FormControl(0),
    softwareId: new FormControl(0),
    cName: new FormControl('', [Validators.required]),
    cDesc: new FormControl(''),
    smsUrl: new FormControl('', [Validators.required]),
    userId: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    senderId: new FormControl('', [Validators.required]),
    channel: new FormControl('', [Validators.required])
  })



  PaginatedDTO: SmsConfigReadAllPaginatedRequestDTO = {
    tenantId: this.User.companyId,
    tenantBranchId: this.User.loggedInBranchId,
    softwareId: parseInt(environment.SoftwareId),
    pageNo: 1,
    pageSize: 10
  }

  ngOnInit(): void {
    this.getSmsConfigList(this.PaginatedDTO);
  }


  openSmsConfigForm() {
    this.smsConfigForm.reset();
    this.addsmsConfigModalContent = this.modalService.open(this.smsConfigModalContent)
    this.smsConfigForm.patchValue({
      smsConfigId: 0,
      companyId: this.User.companyId,
      branchId: this.User.loggedInBranchId,
      softwareId: parseInt(environment.SoftwareId),

    });

  }

  submitSmsConfigForm() {
    this.smsConfigForm.markAllAsTouched();
    if (this.smsConfigForm.valid) {
      this.isSubmitting = true;
      const formData = { ...this.smsConfigForm.value };
      let data: SmsConfigUpdateRequestDTO = {
        smsConfigId: formData.smsConfigId ?? 0,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        softwareId: parseInt(environment.SoftwareId, 10),
        cDesc: formData.cDesc ?? '',
        cName: formData.cName ?? '',
        smsUrl: formData.smsUrl ?? '',
        userId: formData.userId ?? '',
        password: formData.password ?? '',
        senderId: formData.senderId ?? '',
        channel: formData.channel ?? '',
        isActive:  1,
        actionUser: this.User.userId.toString()
      };

      if (formData.smsConfigId && formData.smsConfigId !== 0) {
        this.updateSmsConfigList(data);
      } else {
        this.createSmsConfigList(data);
      }
    }
    else {
      this.isSubmitting = false;
    }
  }

  handleSmsActionClick(event: { actionName: string, rowData: SmsConfigDTO }) {
    const formData = event.rowData;
    if (event.actionName === 'Delete') {
      this.confirmModal.openDeleteModal(formData.cName!, formData).subscribe(res => {
        if (res) {
          const data: SmsConfigRequestDelete = {
            smsConfigId: formData.smsConfigId,
            tenantId: formData.tenantId ?? this.User.companyId,
            tenantBranchId: formData.tenantBranchId ?? this.User.loggedInBranchId,
            actionUser: this.User.userId.toString()
          };

          this.deleteSmsConfig(data);
        }
      });
    }

    if (event.actionName === 'Edit') {
      this.smsConfigForm.patchValue({
        smsConfigId: formData.smsConfigId,
        companyId: formData.tenantId,
        branchId: formData.tenantBranchId,
        softwareId: formData.softwareId,
        cDesc: formData.cDesc,
        cName: formData.cName,
        smsUrl: formData.smsUrl,
        userId: formData.userId || '',
        password: formData.password || '',
        senderId: formData.senderId,
        channel: formData.channel || '',
  
      });
      this.addsmsConfigModalContent = this.modalService.open(this.smsConfigModalContent);
    }
  }

  handlePageSizeChange(event: { currentPage: number; pageSize: number; }) {
    this.PaginatedDTO.pageNo = event.currentPage;
    this.PaginatedDTO.pageSize = event.pageSize;
    this.getSmsConfigList(this.PaginatedDTO)
  }

  getSmsConfigList(data: SmsConfigReadAllPaginatedRequestDTO) {
    this.isLoading = true;
    this.SmsConfigService.SmsConfig_readAllPaginated(data).subscribe({
      next: (res) => {
        this.smsConfigList = res.items;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching config list:', err);
        this.isLoading = false;
      }
    })
  }

  createSmsConfigList(data: SmsConfigCreateRequestDTO): void {
    this.SmsConfigService.SmsConfig_create(data).subscribe({
      next: (res) => {
        this.addsmsConfigModalContent.close()
        this.getSmsConfigList(this.PaginatedDTO)
      this.isSubmitting = false;
      },
      error: (err)=> {
      this.isSubmitting = false;

      }
    })

  }

  updateSmsConfigList(data: SmsConfigUpdateRequestDTO): void {
    this.SmsConfigService.SmsConfig_update(data).subscribe({
      next: (res) => {
        this.addsmsConfigModalContent.close();
        this.getSmsConfigList(this.PaginatedDTO);
      this.isSubmitting = false;
      },
      error: (err) => {
        console.error('Error updating SMS config:', err);
      this.isSubmitting = false;
      }
    });
  }

  deleteSmsConfig(data: SmsConfigRequestDelete) {
    this.SmsConfigService.SmsConfig_delete(data).subscribe({
      next: (res) => {
        this.getSmsConfigList(this.PaginatedDTO);
      }
    })
  }

  passwordFieldType: string = 'password';

  togglePasswordVisibility() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }



}


























